import { useContext } from "react";
import BlueButton from "../Common/BlueButton";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

export default function SuccessSummary({ form }) {
  const navigate = useNavigate();
  console.log("form data:", form);
  const { login } = useContext(AuthContext);

  // const handleGoToDashboard = () => {
  //   const authUserString = localStorage.getItem("authUserData");
  //   let authUser = authUserString ? JSON.parse(authUserString) : null;

  //   if (authUser) {
  //     authUser.is_verified = 7;
  //     localStorage.setItem("authUserData", JSON.stringify(authUser));
  //   }

  //   // Navigate by role
  //   switch (authUser.role) {
  //     case 5: navigate("/retailerdashboard"); break;
  //     case 4: navigate("/agentdashboard"); break;
  //     case 6: navigate("/userdashboard"); break;
  //     case 3: navigate("/empdashboard"); break;
  //     case 2: navigate("/admindashboard"); break;
  //     default: navigate("/");
  //   }
  // };

  const handleGoToDashboard = () => {
  const authUserString = localStorage.getItem("authUserData");
  let authUser = authUserString ? JSON.parse(authUserString) : null;

  if (!authUser) return;

  const updatedUser = {
    ...authUser,
    is_verified: 7,
  };

  // ✅ Update context
  login(updatedUser);

  // ✅ Update localStorage
  localStorage.setItem("authUserData", JSON.stringify(updatedUser));

  // Navigate by role
  switch (updatedUser.role) {
    case 5: navigate("/retailerdashboard"); break;
    case 4: navigate("/agentdashboard"); break;
    case 6: navigate("/userdashboard"); break;
    case 3: navigate("/empdashboard"); break;
    case 2: navigate("/admindashboard"); break;
    default: navigate("/");
  }
};



  return (
    <div className="mt-4">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
          <span className="text-green-600 text-xl">✓</span>
        </div>
        <div>
          <h2 className="text-lg font-semibold text-slate-900">
            All done, onboarding completed!
          </h2>
          <p className="text-sm text-slate-500">
            Your GST and bank details are submitted successfully.
          </p>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        {/* GST Details */}
        <div className="bg-slate-50 rounded-xl p-4">
          <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
            GST Details
          </h3>
          <p className="text-sm text-slate-700">
            <span className="font-medium">Treatment: </span>
            {form.gstTreatment || "-"}
          </p>
          <p className="text-sm text-slate-700 break-all">
            <span className="font-medium">GSTIN / PAN: </span>
            {form.gstin || "-"}
          </p>
          <p className="text-sm text-slate-700">
            <span className="font-medium">Legal Name: </span>
            {form.businessName || "-"}
          </p>
          <p className="text-sm text-slate-700">
            <span className="font-medium">Trade Name: </span>
            {form.tradeName || "-"}
          </p>
        </div>

        {/* Bank Details */}
        <div className="bg-slate-50 rounded-xl p-4">
          <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
            Bank Details
          </h3>
          <p className="text-sm text-slate-700 break-all">
            <span className="font-medium">Account: </span>
            {form.accountNumber || "-"}
          </p>
          <p className="text-sm text-slate-700 break-all">
            <span className="font-medium">IFSC: </span>
            {form.ifsc || "-"}
          </p>
          <p className="text-sm text-slate-700">
            <span className="font-medium">Bank: </span>
            {form.bankName || "-"}
          </p>
          <p className="text-sm text-slate-700">
            <span className="font-medium">Authorised: </span>
            {form.authorisedName || "-"}
          </p>
        </div>

        {/* Go to Dashboard Button */}
        <div>
          <BlueButton
            onClick={handleGoToDashboard}
            className="flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto"
          >
            Go TO Dashboard
          </BlueButton>
        </div>
      </div>
    </div>
  );
}



// import BlueButton from "../Common/BlueButton";
// import { useNavigate } from "react-router-dom";

// export default function SuccessSummary({ form }) {
//   const navigate = useNavigate();
//   console.log("form data:")

//   const handleGoToDashboard = () => {

//     // **Save onboarding completed status**
//     localStorage.setItem("onboard_completed", "true");

//     const authUserString = localStorage.getItem("authUserData");
//     const authUser = authUserString ? JSON.parse(authUserString) : null;
//     const type = authUser?.type; // use 'type' instead of 'role'

//     switch (type) {
//       case "retailer":
//         navigate("/retailerdashboard");
//         break;
//       case "agent":
//         navigate("/agentdashboard");
//         break;
//       case "retailer_user":
//         navigate("/userdashboard");
//         break;
//       case "employee":
//         navigate("/empdashboard");
//         break;
//       case "company":
//         navigate("/admindashboard");
//         break;
//       default:
//         navigate("/"); // fallback
//     }
//   };

//   return (
//     <div className="mt-4">
//       <div className="flex items-center gap-3 mb-4">
//         <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
//           <span className="text-green-600 text-xl">✓</span>
//         </div>
//         <div>
//           <h2 className="text-lg font-semibold text-slate-900">
//             All done, onboarding completed!
//           </h2>
//           <p className="text-sm text-slate-500">
//             Your GST and bank details are submitted successfully.
//           </p>
//         </div>
//       </div>

//       <div className="grid gap-4 md:grid-cols-2">
//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             GST Details
//           </h3>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Treatment: </span>
//             {form.gstTreatment || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">GSTIN / PAN: </span>
//             {form.gstin || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Legal Name: </span>
//             {form.businessName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Trade Name: </span>
//             {form.tradeName || "-"}
//           </p>
//         </div>

//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             Bank Details
//           </h3>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">Account: </span>
//             {form.accountNumber || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">IFSC: </span>
//             {form.ifsc || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Bank: </span>
//             {form.bankName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Authorised: </span>
//             {form.authorisedName || "-"}
//           </p>
//         </div>

//         <div>
//           <BlueButton
//             onClick={handleGoToDashboard}
//             className="flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto"
//           >
//             Go TO Dashboard
//           </BlueButton>
//         </div>
//       </div>
//     </div>
//   );
// }



// import BlueButton from "../Common/BlueButton";
// import { useNavigate } from "react-router-dom";

// export default function SuccessSummary({ form }) {
//   const navigate = useNavigate();

//   const handleGoToDashboard = () => {
//     const authUserString = localStorage.getItem("authUserData");
//     const authUser = authUserString ? JSON.parse(authUserString) : null;
//     const type = authUser?.type; // use 'type' instead of 'role'

//     switch (type) {
//       case "retailer":
//         navigate("/retailerdashboard");
//         break;
//       case "agent":
//         navigate("/agentdashboard");
//         break;
//       case "retailer_user":
//         navigate("/userdashboard");
//         break;
//       case "employee":
//         navigate("/empdashboard");
//         break;
//       case "company":
//         navigate("/admindashboard");
//         break;
//       default:
//         navigate("/"); // fallback
//     }
//   };


//   return (
//     <div className="mt-4">
//       <div className="flex items-center gap-3 mb-4">
//         <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
//           <span className="text-green-600 text-xl">✓</span>
//         </div>
//         <div>
//           <h2 className="text-lg font-semibold text-slate-900">
//             All done, onboarding completed!
//           </h2>
//           <p className="text-sm text-slate-500">
//             Your GST and bank details are submitted successfully.
//           </p>
//         </div>
//       </div>

//       <div className="grid gap-4 md:grid-cols-2">
//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             GST Details
//           </h3>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Treatment: </span>
//             {form.gstTreatment || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">GSTIN / PAN: </span>
//             {form.gstin || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Legal Name: </span>
//             {form.businessName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Trade Name: </span>
//             {form.tradeName || "-"}
//           </p>
//         </div>

//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             Bank Details
//           </h3>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">Account: </span>
//             {form.accountNumber || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">IFSC: </span>
//             {form.ifsc || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Bank: </span>
//             {form.bankName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Authorised: </span>
//             {form.authorisedName || "-"}
//           </p>
//         </div>

//         <div>
//           <BlueButton
//             onClick={handleGoToDashboard}
//             className="flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto"
//           >
//             Go TO Dashboard
//           </BlueButton>
//         </div>
//       </div>
//     </div>
//   );
// }


// import BlueButton from "../Common/BlueButton";

// export default function SuccessSummary({ form }) {
//   return (
//     <div className="mt-4">
//       <div className="flex items-center gap-3 mb-4">
//         <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
//           <span className="text-green-600 text-xl">✓</span>
//         </div>
//         <div>
//           <h2 className="text-lg font-semibold text-slate-900">
//             All done, onboarding completed!
//           </h2>
//           <p className="text-sm text-slate-500">
//             Your GST and bank details are submitted successfully.
//           </p>
//         </div>
//       </div>

//       <div className="grid gap-4 md:grid-cols-2">
//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             GST Details
//           </h3>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Treatment: </span>
//             {form.gstTreatment || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">GSTIN / PAN: </span>
//             {form.gstin || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Legal Name: </span>
//             {form.businessName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Trade Name: </span>
//             {form.tradeName || "-"}
//           </p>
//         </div>

//         <div className="bg-slate-50 rounded-xl p-4">
//           <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
//             Bank Details
//           </h3>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">Account: </span>
//             {form.accountNumber || "-"}
//           </p>
//           <p className="text-sm text-slate-700 break-all">
//             <span className="font-medium">IFSC: </span>
//             {form.ifsc || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Bank: </span>
//             {form.bankName || "-"}
//           </p>
//           <p className="text-sm text-slate-700">
//             <span className="font-medium">Authorised: </span>
//             {form.authorisedName || "-"}
//           </p>
//         </div>
//         <div>
//           <BlueButton
          
//           className="flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto"
//           >
//             Go TO Dashboard
//           </BlueButton>
//         </div>
//       </div>
//     </div>
//   );
// }